
import TrakkenCard from '~/components/ui/TrakkenCard.vue'
import TextBlock from '~/components/ui/TextBlock.vue'
export default {
  props: {
    textBlock: {
      type: Object,
      required: false
    },
    cards: {
      type: Array,
      required: false
    },
    svgFillColor: {
      type: String,
      required: false,
      default: 'rgb(219, 0, 0)'
    }
  },
  data() {
    return {
      showSVG: [],
      centerMode: []
    }
  },
  mounted() {
    if (process.client && this.cards && this.cards.length > 0) {
      this.cards.forEach(() => {
        this.centerMode.push(window.innerWidth > 768)
      })
    }
  },
  methods: {
    setCenterMode(idx, val) {
      val = window.innerWidth < 768 ? false : val
      this.$set(this.centerMode, idx, val)
    }
  },
  components: {
    TextBlock,
    TrakkenCard
  }
  // computed: {
  //   topCard() {
  //     return chunk(this.cards, 1)[0]
  //   },
  //   middleCards() {
  //     let chunked = chunk(this.cards, 1)
  //     return [chunked[1], chunked[2]]
  //   },
  //   bottomCards() {
  //     let chunked = chunk(this.cards, 1)
  //     return [chunked[3], chunked[4]]
  //   }
  // }
}
